import { AnaColumn } from "../forms-template.service";

export const ateco: AnaColumn[] = [

    {
      itemType: "group", colCount: "2", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "Codice", width: "100px" },
  
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione", width: "300px" },
        { type: 'campo', dataField: "note", dataType: "", colSpan: "2",colVisible:false },
        { type: 'campo', dataField: "ordine", dataType: "", colVisible: false },
        { type: 'campo', dataField: "versione", colVisible: false, hideOnEdit: true, dataType: "" },
        { type: 'campo', dataField: "nomeTabella", dataType: "", colVisible: false },
      ]
    },
  ]